import { poaRevalValidator, checkPoaType, formatWithUnit } from "../../../../utils";
import { CHARACTERISTIC, MEASUREMENTS, TREATEMENT, WOUND_IMAGE_LIST } from "./utils";
import { POA_TYPE_OPTIONS, UN_ASSESS_WOUND_TYPE } from "../../../../constants";
import { labelFor, labelsFor } from "../../../common/ConfigForm/optionsFormat";
import { isDispalyBinaryImageNo, isSignWithoutMinimumDatasetEnabled, isUnableToAssessWoundEnabled } from "./ne1.rules";

export const ENABLE_DISABLE_OPTIONS = [
  { key: 1, value: "Enable" },
  { key: 0, value: "Disable" },
];

export const YES_NO_OPTIONS = [
  { key: 1, value: "Yes" },
  { key: 0, value: "No" },
];

const WOUND_SCORE_OPTIONS = [
  { key: "push", value: "Push" },
  { key: "bwat", value: "Bwat" },
];

const RISK_SCALE_OPTIONS = [
  { key: "braden", value: "Braden" },
  { key: "norton", value: "Norton" },
];

const MEASURE_TYPE_OPTIONS = [
  { key: "headtotoe", value: "Head to toe" },
  { key: "longestlength", value: "Longest length" },
];

export const NE1_CUSTOM_VALIDATORS = { poaRevalValidator, checkPoaType };

export const NE1_SECTIONS = [
  {
    key: "woundAssessment",
    title: "Wound Assessment",
    column: "left",
    banner: {
      errorFlagKey: "signOptionError",
      message: "Select at least one from above",
      when: isSignWithoutMinimumDatasetEnabled,
    },
    fields: [
      {
        key: "poa",
        label: "POA",
        control: "text",
        required: true,
        group: "poa",
        validation: { custom: "poaRevalValidator" },
        viewFormat: (data) => `${data.poaWithinHrs ?? ""} ${labelFor(POA_TYPE_OPTIONS, data.poaType) || "Hours"}`.trim(),
      },
      {
        key: "poaType",
        control: "select",
        options: POA_TYPE_OPTIONS,
        group: "poa",
        dataTestId: "select_poaType",
        validation: { custom: "checkPoaType" },
        viewable: false,
      },
      {
        key: "reEval",
        label: "Re-eval",
        control: "text",
        suffix: "Hours",
        viewFormat: (data) => formatWithUnit(data.reEvalWithinHrs, "Hours"),
      },
      { key: "woundAssessmentScore", label: "Wound score", control: "chip", options: WOUND_SCORE_OPTIONS },
      { key: "riskAssessmentScale", label: "Risk score", control: "chip", options: RISK_SCALE_OPTIONS },
      { key: "aiTissueType", label: "AI tissue type", control: "chip", options: ENABLE_DISABLE_OPTIONS },
      {
        key: "aihistorycause",
        label: "AI history/cause",
        control: "chip",
        options: ENABLE_DISABLE_OPTIONS,
        viewFormat: (data) => labelFor(ENABLE_DISABLE_OPTIONS, data.historyCause),
      },
      { key: "copyDataFromPreviousAssessment", label: "Copy data from previous assessment", control: "chip", options: ENABLE_DISABLE_OPTIONS },
      { key: "signWithOutMinimumDataset", label: "Sign without minimum dataset", control: "chip", options: ENABLE_DISABLE_OPTIONS },
      // {
      //   key: "characteristics",
      //   label: "Characteristics",
      //   control: "multiselect",
      //   options: CHARACTERISTIC,
      //   showSelectAll: true,
      //   errorFlagKey: "signOptionError",
      //   visibleWhen: isSignWithoutMinimumDatasetEnabled,
      //   viewFormat: (data) => labelsFor(CHARACTERISTIC, data.signCriteria?.characteristics),
      // },
      // {
      //   key: "measurements",
      //   label: "Measurements",
      //   control: "multiselect",
      //   options: MEASUREMENTS,
      //   showSelectAll: true,
      //   errorFlagKey: "signOptionError",
      //   visibleWhen: isSignWithoutMinimumDatasetEnabled,
      //   viewFormat: (data) => labelsFor(MEASUREMENTS, data.signCriteria?.measurements),
      // },
      // {
      //   key: "treatment",
      //   label: "Treatment",
      //   control: "multiselect",
      //   options: TREATEMENT,
      //   showSelectAll: true,
      //   errorFlagKey: "signOptionError",
      //   visibleWhen: isSignWithoutMinimumDatasetEnabled,
      //   viewFormat: (data) => labelsFor(TREATEMENT, data.signCriteria?.treatment),
      // },
      { key: "unableToAssessWound", label: "Unable to assess wound", control: "chip", options: ENABLE_DISABLE_OPTIONS },
      {
        key: "patientRefusalReasons",
        label: "Reasons",
        control: "multiselect",
        options: UN_ASSESS_WOUND_TYPE,
        required: true,
        errorFlagKey: "reasonError",
        errorMessage: "Select Refusal Reasons",
        visibleWhen: isUnableToAssessWoundEnabled,
      },
    ],
  },
  {
    key: "woundMeasurements",
    title: "Wound Measurements",
    column: "right",
    fields: [
      { key: "measureType", label: "Method", control: "chip", options: MEASURE_TYPE_OPTIONS },
      { key: "woundEdgeAutoTracing", label: "Auto trace", control: "chip", options: ENABLE_DISABLE_OPTIONS },
    ],
  },
  {
    key: "woundPhoto",
    title: "Wound Photo",
    column: "right",
    fields: [
      { key: "isAIWoundCapture", label: "AI-Wound Capture", control: "chip", options: YES_NO_OPTIONS },
      { key: "skipPhoto", label: "Assessment without photo", control: "chip", options: ENABLE_DISABLE_OPTIONS },
      { key: "combinedMultiSegmentIntoOne", label: "Combine multi-segments into one", control: "chip", options: YES_NO_OPTIONS },
      { key: "displayBinaryImage", label: "Display binary image", control: "chip", options: YES_NO_OPTIONS },
      {
        key: "pdfWoundImageType",
        label: "PDF Wound Image",
        control: "select",
        options: WOUND_IMAGE_LIST,
        required: true,
        placeholder: "Select",
        validation: { required: "Wound image is required" },
        visibleWhen: isDispalyBinaryImageNo,
      },
      {
        key: "profileWoundImageType",
        label: "Patient Profile Wound Image",
        control: "select",
        options: WOUND_IMAGE_LIST,
        required: true,
        placeholder: "Select",
        validation: { required: "Wound image is required" },
        visibleWhen: isDispalyBinaryImageNo,
      },

      {
        key: "measurementWoundImageType",
        label: "Measurement Wound Image",
        control: "select",
        options: WOUND_IMAGE_LIST,
        required: true,
        placeholder: "Select",
        validation: { required: "Wound image is required" },
        visibleWhen: isDispalyBinaryImageNo,
      },
      { key: "hasSecondoryPhotos", label: "Secondary photos", control: "chip", options: YES_NO_OPTIONS, disabled: true },
    ],
  },
  {
    key: "pdfReports",
    title: "PDF Reports",
    column: "right",
    fields: [{ key: "isConsolidatedPdfEnable", label: "Consolidated PDF", control: "chip", options: ENABLE_DISABLE_OPTIONS }],
  },
];
